
import { useEffect, useRef } from 'react';
import { mapboxgl } from '../utils/mapboxConfig';
import { Ride } from '@/lib/types/core';
import { addRideMarkers } from '../utils/markerUtils';

interface UseMarkersProps {
  map: React.MutableRefObject<mapboxgl.Map | null>;
  mapLoaded: boolean;
  rides: Ride[];
  loading: boolean;
  userInteracted: boolean;
  selectedRide: Ride | null;
  setSelectedRide: (ride: Ride | null) => void;
}

export const useMarkers = ({
  map,
  mapLoaded,
  rides,
  loading,
  userInteracted,
  selectedRide,
  setSelectedRide
}: UseMarkersProps) => {
  const markersRef = useRef<mapboxgl.Marker[]>([]);
  
  // Handle adding markers
  const addMarkers = () => {
    addRideMarkers(
      map,
      mapLoaded,
      loading,
      rides,
      markersRef,
      userInteracted,
      setSelectedRide
    );
  };
  
  // Update markers when rides change or map loads
  useEffect(() => {
    if (mapLoaded && !loading) {
      addMarkers();
    }
  }, [rides, mapLoaded, loading]);
  
  // Handle closing the preview - ensure markers are visible
  useEffect(() => {
    if (selectedRide === null && mapLoaded && map.current && !loading) {
      // This ensures markers are re-added when closing a preview
      addMarkers();
    }
  }, [selectedRide, mapLoaded, loading]);
  
  return { markersRef, addMarkers };
};
